import { forwardRef } from 'react';
import { View } from '@shared/components/View';
import { ReactionButtonWithPicker } from '@shared/scenes/chat/thread/components/reaction/ReactionButtonWithPicker';
import { API } from '@shared/types/api';
import { useSelectedReactions, useToggleReaction } from './hooks';

interface Props {
  message: API.ChatMessageFragment;
  channelSlug: string;
  anchorName: string;
}

export const MBInvisibleReactionPicker = forwardRef<ReactionButtonWithPicker, Props>(
  function MBInvisibleReactionPickerWithRef({ message, channelSlug, anchorName }, ref) {
    const toggleReaction = useToggleReaction(message, channelSlug);
    const selected = useSelectedReactions(message);

    return (
      <View
        style={{
          height: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
        }}
      >
        <ReactionButtonWithPicker
          ref={ref}
          anchorName={anchorName}
          selected={selected}
          onToggleReaction={toggleReaction}
        />
      </View>
    );
  },
);
